var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{staticClass:"sidebar",attrs:{"collapsed":false,"menu":_vm.menu,"relative":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }